import './ProviderDataStyle.css';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export default function NOAA() {
  return (
    <>
      <div className="dialogWarning">
        MIKE Data Link carries out comprehensive quality control checks on all third-party datasets.
        However, errors and inconsistencies inherited from these datasets (for example, missing
        values) may appear as errors in extracted data. If you encounter incorrect values such as
        NaN or erroneous zero values in extracted boundary conditions, initial conditions, or
        forcings output files, please contact{' '}
        <a href="mailto:mike@dhigroup.com">mike@dhigroup.com.</a>
      </div>
      <div className="dialogSummary">
        The data set from NOAA CFSv2 (Climate Forecast system Version 2) include a selection of
        global-scale meteorological data variables. The Climate Forecast System Version 2 (CFSv2)
        produced by the NOAA National Centers for Environmental Prediction (NCEP) is a fully coupled
        model representing the interaction between the Earth&apos;s oceans, land and atmosphere.
      </div>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              General
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>
              Climate Forecast System Version 2 (CFSv2) Operational Forecasts (from NOAA).
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Coverage</TableCell>
            <TableCell>Global</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Meteorological Parameters</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Source Name</TableCell>
            <TableCell>
              NCEP Climate Forecast System Version 2 (CFSv2), Selected Hourly Timeseries Products
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Publisher</TableCell>
            <TableCell>NOAA, NCEP (National Centers for Environment Prediction)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Cost (ex. VAT)</TableCell>
            <TableCell>Free</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Typical Applications</TableCell>
            <TableCell>Wind, Wave, Hydrodynamic, Offshore and Marine projects</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>References</TableCell>
            <TableCell>
              <a
                href="https://www.ncei.noaa.gov/products/weather-climate-models/climate-forecast-system"
                target="_blank"
                rel="noopener noreferrer">
                Climate Forecast System (CFS) | National Centers for Environmental Information (NCEI) (noaa.gov)
              </a>
              <br />
              <a
                href="https://data.nodc.noaa.gov/cgi-bin/iso?id=gov.noaa.ncdc:C00877"
                target="_blank"
                rel="noopener noreferrer">
                CFSv2 dataset description
              </a>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Coverage
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Geographical Range</TableCell>
            <TableCell>
              Global:
              <br />
              Longitude: -180°W to 180°E
              <br />
              Latitude: -90°S to 90°N
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Resolution</TableCell>
            <TableCell>
              Data variables resolutions (quadratic grid cells): <br />
              Relative humidity and Air pressure: 1.0 deg.
              <br />
              Other items available : 0.2 degree
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Reference</TableCell>
            <TableCell>Sea surface</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Range</TableCell>
            <TableCell>-</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Resolution</TableCell>
            <TableCell>-</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Reference</TableCell>
            <TableCell>UTC</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Range</TableCell>
            <TableCell>
              Data Link coverage: <br />
              1/1-2016 -&gt; Present
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Resolution</TableCell>
            <TableCell>1 hour</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Variables
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Name (Unit)</TableCell>
            <TableCell>
              Air Temperature at 2m [Deg. C.]
              <br />
              Air Pressure at Mean Sea Level [hPa]
              <br />
              Wind velocity components (U & V) at 10m, [m/s]
              <br />
              Relative humidity [%]
              <br />
              Precipitation rate [mm/day]
              <br />
              Cloud cover [%]
              <br />
              Downward Short-Wave Radiation [W/m^2]
              <br />
              Ice Concentration [%]
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Credits
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Cited Authors and Originators</TableCell>
            <TableCell>
              DOC/NOAA/NWS/NCEP &gt; National Centers for Environmental Prediction, National Weather
              Service, NOAA, U.S. Department of Commerce
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Publishers</TableCell>
            <TableCell>
              NOAA National Centers for Environmental Information
              <br />
              <br />
              DOC/NOAA/NESDIS/NCDC &gt; National Climatic Data Center, NESDIS, NOAA, U.S. Department
              of Commerce
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}
